import { FirebaseData } from "../General/FirebaseData";

export class InboxEmailData extends FirebaseData {
  companyID: string = "";
  emailID: string = "";

  setup(data: any): void {
    this.companyID = data.companyID;
    this.emailID = data.emailID;
  }
}

